module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.showing) ? _c('div', {
    class: ( _obj = {}, _obj[_vm.overlayClass] = _vm.overlay, _obj )
  }, [_vm._t("loading-container", [_c('div', {
    class: _vm.loaderClass
  }, [_vm._t("loading-text", [_c('div', {
    staticClass: "pulled-left",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })]), _vm._v(" "), _vm._t("loading-spinner", [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "spinner-container"
  }, [_c('div', {
    staticClass: "spinner-layer spinner-layer--blue"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--red"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--yellow"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-layer spinner-layer--green"
  }, [_c('div', {
    staticClass: "spinner-clipper spinner-clipper--left"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner--patch"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-clipper spinner-clipper--right"
  }, [_c('div', {
    staticClass: "spinner-circle"
  })])])])])])], 2)])], 2) : _vm._e()])
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c50b159"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-full-loading/src/Loading.vue
// module id = 703
// module chunks = 1